import { textStyleCss } from 'src/theme/atlas';
import { FormState } from 'src/types';
import styled from 'styled-components';

export const StyledTextArea = styled.textarea<{
  state: FormState;
  $removeMarginBottom?: boolean;
}>`
  height: 114px;
  width: 100%;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  margin: 8px 0;
  ${(props) => props.$removeMarginBottom && `margin-bottom: 0;`}
  border: 1px solid
    ${(props) => {
    if (props.state === FormState.ERROR)
      return props.theme.atlas.semantic.color.status.error.default;
    if (props.state === FormState.WARNING)
      return props.theme.atlas.semantic.color.status.warning.default;
    if (props.state === FormState.SUCCESS)
      return props.theme.atlas.semantic.color.status.success.default;
    if (props.state === FormState.DISABLED)
      return props.theme.atlas.semantic.color.outline.disabled;
    return props.theme.atlas.semantic.color.outline.default;
  }};
  border-radius: 3px;
  resize: none;
  background-color: ${(props) =>
    props.state === FormState.READONLY
      ? props.theme.atlas.semantic.color.surface.variant
      : props.theme.atlas.semantic.color.surface.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  ${(props) => {
    if (
      props.state === FormState.DISABLED ||
      props.state === FormState.READONLY
    ) {
      return {
        color: props.theme.atlas.semantic.color.type.disabled,
        cursor: 'not-allowed',
      };
    }
  }}
`;
